import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../styles/const/colors'
import { transitionShort } from '../../../styles/const/common'
import { fontWeightBold, fontWeightRegular } from '../../../styles/typography'
import { backBtn } from '../../../styles/common/components'

const useStyles = createUseStyles({
  breadcrumbsRow: {
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 4
  },
  breadcrumbsItem: {
    display: 'flex'
  },
  arrowIcon: {
    margin: '0 16px',
    transform: 'translateY(1px)',
    '& path': {
      fill: darkGrey
    }
  },
  text: {
    whiteSpace: 'noWrap',
    overflow: 'hidden',
    maxWidth: 250,
    textOverflow: 'ellipsis',
    color: darkGrey,
    // todo add transparent border to match height with link
    borderBottom: '1px solid transparent'
  },
  breadcrumbsLink: {
    color: darkGrey,
    textDecoration: 'none',
    borderBottom: `1px solid ${darkGrey}`,
    paddingBottom: 1,
    // To avoid shifting the text during the hover effect, a pseudo-element before has been added.
    // This pseudo element is visually hidden, has a bold font,
    // and occupies the width we need due to the same text as the link.
    // This way, the link doesn't require any extra width during the hover effect.
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: transitionShort,
    fontWeight: fontWeightRegular,
    '&.linkTouched, &:hover, &:active': {
      fontWeight: fontWeightBold
    },
    '&:before': {
      content: 'attr(title)',
      height: 0,
      visibility: 'hidden',
      overflow: 'hidden',
      userSelect: 'none',
      pointerEvents: 'none',
      fontWeight: fontWeightBold
    }
  },
  backBtn: {
    opacity: showBackBtn => (showBackBtn ? 0 : 1),
    pointerEvents: showBackBtn => (showBackBtn ? 'none' : 'auto'),
    extend: backBtn,
    position: 'unset',
    marginBottom: 18
  }
})

export default useStyles
